import React from 'react';

import { ITranslationContextValue } from '../Translate/models/index.js';

import ResultCard from './styledComponents/ResultCard.js';

interface ISearchResultElementsProps {
	groupSearchResults: boolean | undefined;
	id?: string;
	showResults: boolean;
	resultGroupedElements: JSX.Element[];
	resultElements: JSX.Element[];
	translationContext: ITranslationContextValue;
}

export const SearchResultElements: React.FC<ISearchResultElementsProps> = ({
	groupSearchResults = false,
	id,
	showResults,
	resultGroupedElements,
	resultElements,
	translationContext,
}) => {
	let resultContents;
	if (groupSearchResults) {
		resultContents = resultGroupedElements;
	} else {
		resultContents = resultElements;
	}

	const ariaLabel = translationContext.translate('Search Results');
	const resultCardComponent = (
		<ResultCard role="listbox" id={id} aria-label={ariaLabel} aria-live={'polite'}>
			{resultContents}
		</ResultCard>
	);

	if (showResults) {
		return resultCardComponent;
	}
	return null;
};

export default SearchResultElements;
